import { createAsyncThunk } from "@reduxjs/toolkit";
import { type UpdateAddressParams } from "../../../domain/entities/pending-confirmation";
import { type PendingConfirmationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const updateAddress = createAsyncThunk<
  void,
  UpdateAddressParams,
  { dispatch: PendingConfirmationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.UPDATE_ADDRESS, async (params, { extra }) => {
  await extra.contactCenterRepo.updateAddress(params);
});
